import {Box} from "@mui/material"
import {Outlet} from "react-router-dom"
import Header from "./header"
import BackgroundApp from "../../components/illustrations/BackgroundApp"
import Main from "./Main"

export default function RequestLayout() {

    return (
        <>
            <Header/>

            <Box
                sx={{
                    display: {lg: "flex"},
                    minHeight: 1,
                    backgroundImage: `url("${BackgroundApp()}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "bottom"
                }}
            >
                <Main>
                    <Outlet/>
                </Main>
            </Box>
        </>
    )
}